// extracted by mini-css-extract-plugin
export default {"termsAndConditionsLink":"wjw4bAyx9iWd+IHSrB4kbA=="};